export const TYPE_DOCKLE = "dockle";
export const TYPE_TRIVY = "trivy";
export default {};
